import type { Directive } from "vue";
import { sanitizeHtml } from "@/utils/sanitizeHtml";

export const vSanitizedHtml: Directive<HTMLElement, unknown> = {
  mounted(el, binding) {
    el.innerHTML = sanitizeHtml(binding.value);
  },
  updated(el, binding) {
    el.innerHTML = sanitizeHtml(binding.value);
  },
};
